var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82336 10.2692L9.23655 2.8693C9.68028 2.42679 10.2818 2.17824 10.909 2.17824C11.5362 2.17824 12.1377 2.42679 12.5815 2.8693L13.791 4.07191C14.0107 4.29113 14.185 4.55143 14.3039 4.83792C14.4228 5.12441 14.484 5.43149 14.484 5.7416C14.484 6.05172 14.4228 6.35879 14.3039 6.64529C14.185 6.93178 14.0107 7.19207 13.791 7.4113L6.34014 14.8509C5.9362 15.2542 5.38832 15.4808 4.81702 15.4809H1.10001L1.19328 11.7364C1.20691 11.1847 1.43251 10.6594 1.82336 10.2692V10.2692Z",
    stroke: "#9597AE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6558 15.8162C12.1016 16.3433 12.8903 16.4092 13.4174 15.9634C13.9445 15.5175 14.0104 14.7288 13.5646 14.2017L3.11131 1.8434C2.66548 1.31631 1.87677 1.25044 1.34968 1.69628C0.822591 2.14211 0.756722 2.93082 1.20256 3.45791L11.6558 15.8162Z",
    fill: "#9597AE",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPass);
export default __webpack_public_path__ + "static/media/pass.abb9e881decba20685fc2508d3571dbb.svg";
export { ForwardRef as ReactComponent };